var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("div", { staticClass: "spu-title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Brand SPU ID", required: true } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "16",
                      "show-word-limit": "",
                      onkeyup:
                        "value=value.replace(/[^a-zA-Z0-9-]/g,'');if(value&&value.length>17)value=value.substring(0,16)"
                    },
                    model: {
                      value: _vm.form["productId"],
                      callback: function($$v) {
                        _vm.$set(_vm.form, "productId", $$v)
                      },
                      expression: "form['productId']"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.productId,
                          expression: "!form.productId"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product Id can't be blank")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.productId && _vm.productIdRepeat,
                          expression: "form.productId && productIdRepeat "
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Duplicate SPU ID, please modify")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Title", required: true } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "120", "show-word-limit": "" },
                    model: {
                      value: _vm.form.title,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.title,
                          expression: "!form.title"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product title can't be blank")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Category", required: true } },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "40%" },
                      attrs: {
                        filterable: "",
                        placeholder: "Please Select Category"
                      },
                      on: { change: _vm.changeCate },
                      model: {
                        value: _vm.form.cateId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cateId", $$v)
                        },
                        expression: "form.cateId"
                      }
                    },
                    _vm._l(_vm.categoryList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.cateId,
                          expression: "!form.cateId"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product Category can't be blank")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.cateId && _vm.form.categoryIsOutOfStock,
                          expression: "form.cateId && form.categoryIsOutOfStock"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [
                      _vm._v(
                        "\n            This product category has been removed, the website cannot display this product, please update the category\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  attrs: { label: "Brand", required: true }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "40%" },
                      attrs: {
                        clearable: "",
                        placeholder: "Please select Brand",
                        remote: "",
                        filterable: "",
                        "reserve-keyword": "",
                        "remote-method": _vm.loadBrands
                      },
                      on: { change: _vm.changBrand },
                      model: {
                        value: _vm.form["collectionBrandId"],
                        callback: function($$v) {
                          _vm.$set(_vm.form, "collectionBrandId", $$v)
                        },
                        expression: "form['collectionBrandId']"
                      }
                    },
                    _vm._l(_vm.brandOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.collectionBrandId,
                          expression: "!form.collectionBrandId"
                        }
                      ],
                      staticClass: "required-form-error cust-form-item-spu"
                    },
                    [_vm._v("Please select Brand")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  attrs: { label: "Shipping from country", required: true }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "cust-form-item-spu",
                      attrs: { name: "shippingCountryCode" },
                      on: { input: _vm.changeShippingCountry },
                      model: {
                        value: _vm.form.shippingCountryCode,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shippingCountryCode", $$v)
                        },
                        expression: "form.shippingCountryCode"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("China")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("USA")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.shippingCountryCode,
                          expression: "!form.shippingCountryCode"
                        }
                      ],
                      staticClass: "required-form-error cust-form-item-spu"
                    },
                    [_vm._v("Please select a shipping country")]
                  ),
                  _vm._v(" "),
                  _vm.form["reviewContentList"] &&
                  _vm.form["reviewContentList"].filter(function(f) {
                    return f["reviewContent"] == "shipping_country_code"
                  }).length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "required-error",
                          staticStyle: { "margin-top": "2px" }
                        },
                        [
                          _vm._v(
                            "\n            modify is " +
                              _vm._s(
                                _vm._f("disUpdateAfterValueShippingcode")(
                                  _vm.form["reviewContentList"].filter(function(
                                    f
                                  ) {
                                    return (
                                      f["reviewContent"] ==
                                      "shipping_country_code"
                                    )
                                  })
                                )
                              ) +
                              ", under review\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  attrs: { label: "Shipping Fee" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "cust-form-item-spu",
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.isFreeShipping,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "isFreeShipping", $$v)
                        },
                        expression: "form.isFreeShipping"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Shipping Fee")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Non free")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Description", required: true } },
                [
                  _c("QuillEditor", {
                    staticStyle: { "margin-top": "40px" },
                    on: { resultDesciption: _vm.resultDesciption }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.descInfo,
                          expression: "!descInfo"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product description can't be blank")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("p", { staticClass: "is-required" }, [
                    _c("span", { staticStyle: { color: "#F56C6C" } }, [
                      _vm._v("*")
                    ]),
                    _vm._v(" Product Photos")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "sub-title" }, [
                    _vm._v(
                      "Product images showcase your product clearly and usually shot on a white background.\n              (Ideal Size: Square - 800 x 800 or higher,up to 30 sheets supported)"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pro-photo" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: _vm.uploadApi,
                        "list-type": "picture-card",
                        accept: ".jpeg,.png,.jpg",
                        multiple: "",
                        limit: 30,
                        "on-preview": _vm.handlePictureCardPreview,
                        "file-list": _vm.spuFilelist,
                        "on-remove": _vm.handleRemove,
                        "http-request": _vm.uploadRequest,
                        "on-success": _vm.handleSuccess
                      },
                      on: {
                        "update:fileList": function($event) {
                          _vm.spuFilelist = $event
                        },
                        "update:file-list": function($event) {
                          _vm.spuFilelist = $event
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.spuFilelist || _vm.spuFilelist.length < 1,
                          expression: "!spuFilelist || spuFilelist.length<1"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product photos can't be blank\n          ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "variant" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "variant-sub-title" }, [
                _c("div", [_vm._v(_vm._s(_vm.totalSkuCount) + " Variant")]),
                _vm._v(" "),
                _c("div", { on: { click: _vm.showVariant } }, [
                  _vm._v("Add Variant")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      key: _vm.tableKey,
                      ref: "table",
                      attrs: { data: _vm.table, stripe: "" }
                    },
                    [
                      _c("el-table-column", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        attrs: { label: "id", width: "5", fixed: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return undefined
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.tableColumn, function(item, key) {
                        return [
                          item == "Image"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "100", fixed: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          item == "Image"
                                            ? _c(
                                                "div",
                                                { staticClass: "tableImage" },
                                                [
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      key: key,
                                                      staticClass:
                                                        "avatar-uploader",
                                                      attrs: {
                                                        action: _vm.uploadApi,
                                                        disabled:
                                                          scope["row"][
                                                            "isDeleted"
                                                          ],
                                                        "list-type":
                                                          "picture-card",
                                                        accept:
                                                          ".jpeg,.png,.jpg",
                                                        "file-list":
                                                          _vm.skuFileList[
                                                            scope.$index
                                                          ],
                                                        limit: 1,
                                                        "on-preview":
                                                          _vm.handlePictureCardPreview,
                                                        "on-remove": function(
                                                          file,
                                                          fileList
                                                        ) {
                                                          return _vm.handleSkuRemove(
                                                            file,
                                                            fileList,
                                                            scope.$index
                                                          )
                                                        },
                                                        "on-success": function(
                                                          response,
                                                          file,
                                                          fileList
                                                        ) {
                                                          return _vm.handleSkuSuccess(
                                                            response,
                                                            file,
                                                            fileList,
                                                            scope.$index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      scope["row"][item]
                                                        ? _c("img", {
                                                            staticClass:
                                                              "avatar",
                                                            attrs: {
                                                              src:
                                                                scope["row"][
                                                                  item
                                                                ]
                                                            }
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "el-icon-plus avatar-uploader-icon"
                                                          })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Brand SKU ID"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "200" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                ref: "inputRef",
                                                refInFor: true,
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"]
                                                },
                                                on: {
                                                  input: function(event) {
                                                    return _vm.changeBrandSkuCode(
                                                      event,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                nativeOn: {
                                                  keydown: function($event) {
                                                    return _vm.clickBrandSkuCode(
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !scope["row"]["isDeleted"]
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !scope["row"][
                                                          item
                                                        ],
                                                        expression:
                                                          "!scope['row'][item]"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "required-error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Brand SKU ID can't be blank"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                scope["row"][item] &&
                                                scope["row"]["isRepeatBrandSku"]
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "required-error"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Duplicate SKU ID, please modify"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Case"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "80" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Case\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: { "data-key": "Case" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Case"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value<=0){value=1} if(value>100){value=100}",
                                                  maxlength: 3,
                                                  minlength: 1
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              scope.$index == 0 &&
                                              _vm.skuIsDiglog &&
                                              _vm.curSkuBlukField == "Case"
                                                ? _c("sku-bluk-set", {
                                                    attrs: { field: "Case" }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "FOB Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                staticClass: "cust-table-column",
                                attrs: { label: item, width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      FOB Price($)\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(scope["row"][item])
                                                )
                                              ]),
                                              _vm._v(" "),
                                              !scope["row"]["isDeleted"]
                                                ? [
                                                    scope["row"][
                                                      "svGoodsReviewLogList"
                                                    ] &&
                                                    scope["row"][
                                                      "svGoodsReviewLogList"
                                                    ].filter(function(f) {
                                                      return (
                                                        f["reviewContent"] ==
                                                        "fob_price"
                                                      )
                                                    }).length > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "required-error",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "13px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          modify is " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "disUpdateAfterValue"
                                                                  )(
                                                                    scope[
                                                                      "row"
                                                                    ][
                                                                      "svGoodsReviewLogList"
                                                                    ],
                                                                    "fob_price"
                                                                  )
                                                                ) +
                                                                ", under\n                          review\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Cost Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                staticClass: "cust-table-column",
                                attrs: { label: item, width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Cost Price($)\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key": "Cost Price"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Cost Price"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                                },
                                                on: {
                                                  blur: function(event) {
                                                    return _vm.blurCostPriceFob(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              !scope["row"]["isDeleted"]
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: !scope[
                                                              "row"
                                                            ][item],
                                                            expression:
                                                              "!scope['row'][item]"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "required-error"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Cost Price can’t be blank"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    scope["row"][
                                                      "svGoodsReviewLogList"
                                                    ] &&
                                                    scope["row"][
                                                      "svGoodsReviewLogList"
                                                    ].filter(function(f) {
                                                      return (
                                                        f["reviewContent"] ==
                                                        "source_price"
                                                      )
                                                    }).length > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "required-error",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "13px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          modify is " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "disUpdateAfterValue"
                                                                  )(
                                                                    scope[
                                                                      "row"
                                                                    ][
                                                                      "svGoodsReviewLogList"
                                                                    ],
                                                                    "source_price"
                                                                  )
                                                                ) +
                                                                ",\n                          under review\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.$index == 0 &&
                                              _vm.skuIsDiglog &&
                                              _vm.curSkuBlukField ==
                                                "Cost Price"
                                                ? _c("sku-bluk-set", {
                                                    attrs: {
                                                      field: "Cost Price"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item === "Wholesale Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { width: "180", label: item },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Wholesale Price($)\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key": "Wholesale Price"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Wholesale Price"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"] ||
                                                    _vm.disableFormFlag,
                                                  oninput:
                                                    "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                                },
                                                on: {
                                                  blur: function(event) {
                                                    return _vm.blurCif(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              !scope["row"]["isDeleted"]
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: !scope[
                                                              "row"
                                                            ][item],
                                                            expression:
                                                              "!scope['row'][item]"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "required-error"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Wholesale Price can’t be blank"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    scope["row"][
                                                      "svGoodsReviewLogList"
                                                    ] &&
                                                    scope["row"][
                                                      "svGoodsReviewLogList"
                                                    ].filter(function(f) {
                                                      return (
                                                        f["reviewContent"] ==
                                                        "cif_price"
                                                      )
                                                    }).length > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "required-error",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "22px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          modify is " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "disUpdateAfterValue"
                                                                  )(
                                                                    scope[
                                                                      "row"
                                                                    ][
                                                                      "svGoodsReviewLogList"
                                                                    ],
                                                                    "cif_price"
                                                                  )
                                                                ) +
                                                                ", under\n                          review\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.$index == 0 &&
                                              _vm.skuIsDiglog &&
                                              _vm.curSkuBlukField ==
                                                "Wholesale Price"
                                                ? _c("sku-bluk-set", {
                                                    attrs: {
                                                      field: "Wholesale Price"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Wholesale Settlement Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                staticClass: "cust-table-column",
                                attrs: { label: item, width: "250" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Wholesale Settlement Price($)\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key":
                                                    "Wholesale Settlement Price"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Wholesale Settlement Price"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  oninput:
                                                    "\n                                if(value){value=value.replace(/[^0-9.]/g,'')}\n                                if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}",
                                                  disabled:
                                                    scope["row"]["isDeleted"]
                                                },
                                                on: {
                                                  change: function(val) {
                                                    scope["row"][item] =
                                                      val || 0
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              scope.$index == 0 &&
                                              _vm.skuIsDiglog &&
                                              _vm.curSkuBlukField ==
                                                "Wholesale Settlement Price"
                                                ? _c("sku-bluk-set", {
                                                    attrs: {
                                                      field:
                                                        "Wholesale Settlement Price"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item === "Retail Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { width: "200", label: item },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Retail Price($)\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key": "Retail Price"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Retail Price"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                                },
                                                on: {
                                                  change: function(event) {
                                                    return _vm.blurRetailPriceFob(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              !scope["row"]["isDeleted"]
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              Number(
                                                                scope["row"][
                                                                  "Wholesale Price($)"
                                                                ]
                                                              ) > 0 &&
                                                              (Number(
                                                                scope["row"][
                                                                  "Retail Price($)"
                                                                ]
                                                              ) -
                                                                Number(
                                                                  scope["row"][
                                                                    "Wholesale Price($)"
                                                                  ]
                                                                )) /
                                                                Number(
                                                                  scope["row"][
                                                                    "Retail Price($)"
                                                                  ]
                                                                ) <=
                                                                0.3,
                                                            expression:
                                                              "Number(scope['row']['Wholesale Price($)'])>0 && ( (Number(scope['row']['Retail Price($)'])-Number(scope['row']['Wholesale Price($)']))/Number(scope['row']['Retail Price($)']) ) <=0.3  "
                                                          }
                                                        ],
                                                        staticClass:
                                                          "required-error",
                                                        staticStyle: {
                                                          "margin-top": "13px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Ensure >30% margin vs. wholesale price.\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.$index == 0 &&
                                              _vm.skuIsDiglog &&
                                              _vm.curSkuBlukField ==
                                                "Retail Price"
                                                ? _c("sku-bluk-set", {
                                                    attrs: {
                                                      field: "Retail Price"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Weight(g)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "110" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Weight(g)\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: { "data-key": "Weight" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Weight"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>10000){value=10000}"
                                                },
                                                on: {
                                                  change: function(event) {
                                                    return _vm.blurWeight(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !scope["row"]["isDeleted"]
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !scope["row"][
                                                          item
                                                        ],
                                                        expression:
                                                          "!scope['row'][item]"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "required-error"
                                                  },
                                                  [_vm._v("Can't be blank")]
                                                ),
                                                _vm._v(" "),
                                                scope["row"][
                                                  "svGoodsReviewLogList"
                                                ] &&
                                                scope["row"][
                                                  "svGoodsReviewLogList"
                                                ].filter(function(f) {
                                                  return (
                                                    f["reviewContent"] ==
                                                    "weight"
                                                  )
                                                }).length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "required-error",
                                                        staticStyle: {
                                                          "margin-top": "13px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        modify is " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "disUpdateAfterValueWeight"
                                                              )(
                                                                _vm._f(
                                                                  "disUpdateAfterValueObj"
                                                                )(
                                                                  scope["row"][
                                                                    "svGoodsReviewLogList"
                                                                  ],
                                                                  "weight"
                                                                )
                                                              )
                                                            ) +
                                                            ", under review\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.$index == 0 &&
                                          _vm.skuIsDiglog &&
                                          _vm.curSkuBlukField == "Weight"
                                            ? _c("sku-bluk-set", {
                                                attrs: { field: "Weight" }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Inventory"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "190" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Inventory\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key": "Inventory"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Inventory"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  maxlength: 5,
                                                  minlength: 1,
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/[^\\d]/g,'')}  if(value>10000){value=10000}"
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !scope["row"]["isDeleted"]
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: !scope["row"][
                                                          item
                                                        ],
                                                        expression:
                                                          "!scope['row'][item]"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "required-error"
                                                  },
                                                  [_vm._v("Can't be blank")]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.$index == 0 &&
                                          _vm.skuIsDiglog &&
                                          _vm.curSkuBlukField == "Inventory"
                                            ? _c("sku-bluk-set", {
                                                attrs: { field: "Inventory" }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "status"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: "Availability", width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Availability\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key": "Availability"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Availability"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope["row"]["showStatusSelect"]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-cell-input"
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "Please Select",
                                                        disabled:
                                                          _vm.goodsStatusDb ==
                                                            "0" ||
                                                          scope["row"][
                                                            "isDeleted"
                                                          ]
                                                      },
                                                      on: {
                                                        change: function(e) {
                                                          return _vm.changeSkuStatus(
                                                            e,
                                                            scope["row"],
                                                            scope.$index
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          scope["row"][item],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope["row"],
                                                            item,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope['row'][item]"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.skuStatusOptions,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value
                                                          }
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-cell-input"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        color: "#FB541C"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Restock by " +
                                                          _vm._s(
                                                            scope["row"][
                                                              "restockDate"
                                                            ]
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !scope["row"]["isDeleted"]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cust-sku-btn",
                                                          staticStyle: {
                                                            "text-align": "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.resetRestock(
                                                                    scope[
                                                                      "row"
                                                                    ],
                                                                    scope.$index
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Restock")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              on: {
                                                                click: function(
                                                                  e
                                                                ) {
                                                                  return _vm.changeSkuRestockDate(
                                                                    e,
                                                                    scope["row"]
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Change Date"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "cust-sku-btn",
                                                          staticStyle: {
                                                            "text-align": "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "unset"
                                                              }
                                                            },
                                                            [_vm._v("Restock")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "unset"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Change Date"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope["row"]["tmpStatus"] ==
                                                      "99" && !_vm.skuIsDiglog,
                                                  expression:
                                                    "scope['row']['tmpStatus']=='99' && !skuIsDiglog"
                                                }
                                              ],
                                              staticClass: "set-restock-date"
                                            },
                                            [
                                              _c("p", [
                                                _vm._v("Set restock date")
                                              ]),
                                              _vm._v(" "),
                                              _c("el-date-picker", {
                                                staticStyle: {
                                                  "margin-top": "10px"
                                                },
                                                attrs: {
                                                  type: "date",
                                                  disabled:
                                                    _vm.goodsStatusDb == "0",
                                                  "value-format": "MM/dd/yyyy",
                                                  placeholder: "MM/DD/YYYY",
                                                  format: "MM/dd/yyyy"
                                                },
                                                model: {
                                                  value:
                                                    _vm.restockDateArr[
                                                      scope.$index
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.restockDateArr,
                                                      scope.$index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "restockDateArr[scope.$index]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm
                                                        .restockDateArr[
                                                        scope.$index
                                                      ],
                                                      expression:
                                                        "!restockDateArr[scope.$index]"
                                                    }
                                                  ],
                                                  staticClass: "required-error"
                                                },
                                                [
                                                  _vm._v(
                                                    "Please set restock date"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cust-sku-btn" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.submitRestockDate(
                                                            scope["row"],
                                                            scope.$index,
                                                            false
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Cancel")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.submitRestockDate(
                                                            scope["row"],
                                                            scope.$index,
                                                            true
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Save")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !scope["row"]["isDeleted"]
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.goodsStatusDb ==
                                                          "0",
                                                        expression:
                                                          "goodsStatusDb == '0'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "required-error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Please set SPU Active first"
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.$index == 0 &&
                                          _vm.skuIsDiglog &&
                                          _vm.curSkuBlukField == "Availability"
                                            ? _c("sku-bluk-set", {
                                                attrs: { field: "Availability" }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Dimensions - L/W/H(cm)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "220" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "cust-title" },
                                            [
                                              _vm._v(
                                                "\n                      Dimensions - L/W/H(cm)\n                      "
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                                attrs: {
                                                  "data-key": "Dimensions"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skuSetDiglog(
                                                      "Dimensions"
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "50px" },
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value>1000){value=1000}",
                                                  placeholder: "Length"
                                                },
                                                model: {
                                                  value: scope["row"]["length"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      "length",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row']['length']"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                staticStyle: { width: "50px" },
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>1000){value=1000}",
                                                  placeholder: "Width"
                                                },
                                                model: {
                                                  value: scope["row"]["width"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      "width",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row']['width']"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                staticStyle: { width: "50px" },
                                                attrs: {
                                                  disabled:
                                                    scope["row"]["isDeleted"],
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>1000){value=1000}",
                                                  placeholder: "High"
                                                },
                                                model: {
                                                  value: scope["row"]["height"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      "height",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row']['height']"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !scope["row"]["isDeleted"]
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          !scope["row"][
                                                            "length"
                                                          ] ||
                                                          !scope["row"][
                                                            "width"
                                                          ] ||
                                                          !scope["row"][
                                                            "height"
                                                          ],
                                                        expression:
                                                          "!scope['row']['length'] || !scope['row']['width'] || !scope['row']['height']"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "required-error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "L/W/H\n                        (cm) can't be blank\n                      "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.$index == 0 &&
                                          _vm.skuIsDiglog &&
                                          _vm.curSkuBlukField == "Dimensions"
                                            ? _c("sku-bluk-set", {
                                                attrs: { field: "Dimensions" }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item === "Vd_SKU ID"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: {
                                  label: item,
                                  width: _vm.calcWidth(item),
                                  fixed: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(scope["row"][item] || "-")
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item !== "length" &&
                              item !== "width" &&
                              item !== "height" &&
                              item !== "countryCode" &&
                              item !== "serviceFee" &&
                              item !== "isDirectlyModifyNetPrice" &&
                              item !== "orlNetPrice" &&
                              item !== "restockDate" &&
                              item !== "skuCharacterList" &&
                              item !== "restockDateMmddyyyy" &&
                              item !== "Procurement Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: {
                                  label: item,
                                  width: _vm.calcWidth(item)
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(_vm._s(scope["row"][item]))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e()
                        ]
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Action", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !scope["row"]["isDeleted"]
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteSku(
                                            scope["row"],
                                            true
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                scope["row"]["isDeleted"]
                                  ? _c("i", {
                                      staticClass: "el-icon-refresh-right",
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteSku(
                                            scope["row"],
                                            false
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showAllDeleteVariantMsg
                ? _c("div", { staticClass: "all-delete-variant-msg" }, [
                    _c("span", { on: { click: _vm.showVariant } }, [
                      _vm._v("Please add product Variant first")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.skuRepeatFlag
                ? _c("div", { staticClass: "required-error" }, [
                    _vm._v(
                      "\n           " + _vm._s(_vm.skuRepeat) + "\n          "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content",
                staticStyle: { "padding-bottom": "10px" }
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { name: "changeCommodityAttributes" },
                        on: { change: _vm.changeCommodityAttributes },
                        model: {
                          value: _vm.form.commodityAttributes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "commodityAttributes", $$v)
                          },
                          expression: "form.commodityAttributes"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 4 } }, [
                          _vm._v("Ordinary")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("Sensitive")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("Cosmetic")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 3 } }, [
                          _vm._v("Apparel")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 5 } }, [
                          _vm._v("Synthetic Wig")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-checkbox", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAdmin,
                          expression: "isAdmin"
                        }
                      ],
                      staticStyle: { "margin-left": "20px" },
                      attrs: { label: "Special", name: "type" },
                      on: { change: _vm.changeIsSpecial },
                      model: {
                        value: _vm.form.isSpecial,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "isSpecial", $$v)
                        },
                        expression: "form.isSpecial"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.form.commodityAttributes &&
                          (!_vm.form["reviewContentList"] ||
                            (_vm.form["reviewContentList"] &&
                              _vm.form["reviewContentList"].filter(function(f) {
                                return (
                                  f["reviewContent"] == "commodity_attributes"
                                )
                              }).length == 0)),
                        expression:
                          "!form.commodityAttributes && (!form['reviewContentList'] || (form['reviewContentList'] && form['reviewContentList'].filter(f=>f['reviewContent']=='commodity_attributes').length==0))"
                      }
                    ],
                    staticClass: "required-error"
                  },
                  [
                    _vm._v(
                      "\n            Please select Commodity attributes\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.form["reviewContentList"] &&
                _vm.form["reviewContentList"].filter(function(f) {
                  return f["reviewContent"] == "commodity_attributes"
                }).length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "required-error",
                        staticStyle: { "margin-top": "2px" }
                      },
                      [
                        _vm._v(
                          "\n            modify is " +
                            _vm._s(
                              _vm._f("disUpdateAfterValueCommodityAttributes")(
                                _vm.form["reviewContentList"].filter(function(
                                  f
                                ) {
                                  return (
                                    f["reviewContent"] == "commodity_attributes"
                                  )
                                })
                              )
                            ) +
                            ", under review\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-right": "20px" } },
                  [
                    _c("span", { staticClass: "cust-name" }, [
                      _vm._v("SPU Customs Name_cn")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "cust-name-input",
                      attrs: { maxlength: "50", "show-word-limit": "" },
                      on: { input: _vm.inputCnChange },
                      model: {
                        value: _vm.form.cnProductName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cnProductName", $$v)
                        },
                        expression: "form.cnProductName"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.form.shippingCountryCode == 1 &&
                              !_vm.form.cnProductName,
                            expression:
                              "form.shippingCountryCode==1 && !form.cnProductName"
                          }
                        ],
                        staticClass: "required-form-error"
                      },
                      [
                        _vm._v(
                          "\n                Please fill in SPU Customs Name_cn\n              "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("span", { staticClass: "cust-name" }, [
                      _vm._v("SPU Customs Name_en")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "cust-name-input",
                      attrs: {
                        maxlength: "50",
                        onkeyup: "value=value.replace(/[^\\x00-\\xff]/g, '')",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.form.enProductName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "enProductName", $$v)
                        },
                        expression: "form.enProductName"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.form.shippingCountryCode == 1 &&
                              !_vm.form.enProductName,
                            expression:
                              "form.shippingCountryCode==1 && !form.enProductName"
                          }
                        ],
                        staticClass: "required-form-error"
                      },
                      [
                        _vm._v(
                          "\n                Please fill in SPU Customs Name_en\n              "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "Please Select" },
                    model: {
                      value: _vm.form.goodsStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "goodsStatus", $$v)
                      },
                      expression: "form.goodsStatus"
                    }
                  },
                  _vm._l(_vm.goodsStatusOptions, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.form["reviewContentList"] &&
                _vm.form["reviewContentList"].filter(function(f) {
                  return f["reviewContent"] == "goods_status"
                }).length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "required-form-error",
                        staticStyle: { "margin-top": "13px" }
                      },
                      [
                        _vm._v(
                          "\n            modify is " +
                            _vm._s(
                              _vm._f("disUpdateAfterValueStatus")(
                                _vm.form["reviewContentList"].filter(function(
                                  f
                                ) {
                                  return f["reviewContent"] == "goods_status"
                                })
                              )
                            ) +
                            ", under review\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-list", staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-button",
            {
              staticClass: "save-button",
              attrs: { type: "primary" },
              on: { click: _vm.save }
            },
            [_vm._v("\n        Publish\n      ")]
          ),
          _vm._v(" "),
          _c("el-button", { attrs: { plain: "" }, on: { click: _vm.cancel } }, [
            _vm._v("\n        cancel\n      ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.checkResult,
                  expression: "!checkResult"
                }
              ],
              staticClass: "required-error"
            },
            [_vm._v("\n        Please check all fields\n      ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c("sku-variant", { ref: "skuVariant" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "variant-title" }, [
      _c("p", [_vm._v("Variant")]),
      _vm._v(" "),
      _c("p", { staticClass: "sub-title" }, [
        _vm._v(
          "Add variants to your product if it comes in more than one option such as size or\n              color."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" Commodity attributes")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" Customs Name")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" Status")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66464550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66464550","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/spuDetails/create-spu.vue
// module id = vjFF
// module chunks = 2